import QuestionAndAnswerListItem from "./QuestionAndAnswerListItem";

export default function QuestionAndAnswerList({ formQnA }) {
  return (
    <div className="flex h-full flex-col gap-1">
      {Array.isArray(formQnA) &&
        formQnA.map((qNa) => <QuestionAndAnswerListItem data={qNa} />)}
    </div>
  );
}
